<div [formGroup]="contactDetailsForm" class="admin-dialog__section">
  <div class="form-label">
    <span class="form-label__text form-label__text--section" i18n="@@adminSystem.distributorDetails.label.contactDetails">連絡先</span>
  </div>

  <div class="admin-dialog__field-row">
    <mat-form-field appearance="outline" class="form-field form-field--half">
      <mat-label i18n="@@adminSystem.distributorDetails.label.phone">電話番号</mat-label>
      <input matInput formControlName="phone" />
      <mat-icon matSuffix class="material-icons-outlined form-field__contact-icon">phone</mat-icon>
      @if (contactDetailsForm.get('phone')?.hasError('required')) {
        <mat-error i18n="@@adminSystem.distributorDetails.error.required">必須項目です</mat-error>
      }
    </mat-form-field>
    
    <mat-form-field appearance="outline" class="form-field form-field--half">
      <mat-label i18n="@@adminSystem.distributorDetails.label.mobile">携帯電話番号</mat-label>
      <input matInput formControlName="mobile" />
      <mat-icon matSuffix class="material-icons-outlined form-field__contact-icon">smartphone</mat-icon>
    </mat-form-field>
  </div>

  <mat-form-field appearance="outline" class="form-field">
    <mat-label i18n="@@adminSystem.distributorDetails.label.email">e-mail</mat-label>
    <input matInput formControlName="email" />
    <mat-icon matSuffix class="material-icons-outlined form-field__contact-icon">mail</mat-icon>
    @if (contactDetailsForm.get('email')?.hasError('required')) {
      <mat-error i18n="@@adminSystem.distributorDetails.error.required">必須項目です</mat-error>
    }
    @if (contactDetailsForm.get('email')?.hasError('email')) {
      <mat-error i18n="@@adminSystem.distributorDetails.error.required">メールアドレスのフォーマットが誤っています</mat-error>
    }
  </mat-form-field>
</div>
